import WrittenReviewCommentItem from './WrittenReviewCommentItem';
import useStyles from './useStyles';

import { FetchQuotationPartnerRfqReviewQuery } from '@generated/graphql';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { ChevronDown } from '@carbon/icons-react';

interface Props {
  reviewInfo?: FetchQuotationPartnerRfqReviewQuery['fetchQuotationPartnerRfqReview']['data'];
  visibleCount: number;
  handleVisibleCount: () => void;
}
const WrittenReviewPresenter = ({
  reviewInfo,
  visibleCount,
  handleVisibleCount
}: Props) => {
  const classes = useStyles();

  const reviews = reviewInfo?.reviews ?? [];

  const reviewsTotalCount = reviews.length;

  const invisibleMoreButton =
    visibleCount === reviewsTotalCount || reviewsTotalCount < 5;

  return (
    <div className={classes.root}>
      {reviews.length === 0 && (
        <div className="no-review">
          <CustomizedTypography variant="h4" color="textSecondary">
            받은 리뷰가 없습니다.
          </CustomizedTypography>
        </div>
      )}

      {reviews.slice(0, visibleCount).map((review, index) => (
        <WrittenReviewCommentItem
          key={review.id}
          index={index}
          review={review}
        />
      ))}

      {invisibleMoreButton ? null : (
        <div className={classes.visibie}>
          <CustomizedButton
            size="medium"
            color="default"
            onClick={handleVisibleCount}
            endIcon={<ChevronDown size={20} />}
          >
            더보기
          </CustomizedButton>
        </div>
      )}
    </div>
  );
};

export default WrittenReviewPresenter;
